export default __webpack_public_path__ + "static/media/home-interactive-portfolio-img-02.77054008.jpg";